// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__11jEC","filesListContainer":"PosDisputesFiles_filesListContainer__3ghew","filesButton":"PosDisputesFiles_filesButton__1Oc30"};